import React, { useState } from 'react';

import styled from 'styled-components';

import { DISPLAY_DATE_FORMAT } from '@cd3p/core/utils/common';
import { FormField } from 'components';

import { dayjs, useFormContext } from 'third-party';

import { FormFieldProps } from 'components/FormField/FormField';
import { DesktopDatePicker } from 'components/index';

const StyledDatepicker = styled(DesktopDatePicker)`
  width: 100%;
`;

const popperDateSx = {
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '1.6rem',
    textTransform: 'uppercase',
    fontWeight: 900,
  },
  '& .PrivatePickersYear-yearButton': {
    fontSize: '1.6rem',
    margin: '0.4rem 0',
    '&.Mui-selected': {
      color: '#ffffff',
    },
  },
  '& .MuiPickersDay-dayWithMargin': {
    fontSize: '1.6rem',
    color: '#5C6C80',
    '&[aria-selected="true"]': {
      color: '#ffffff',
    },
    '&[aria-current="date"]': {
      borderColor: '#AFD8D4',
      backgroundColor: '#AFD8D4',
    },
  },
};

type DateFieldProps = FormFieldProps;

export const DateField: React.FC<DateFieldProps> = ({ ...props }) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  const {
    formState: { errors },
  } = useFormContext();

  return (
    <FormField
      render={({ field }) => (
        <StyledDatepicker
          open={datePickerOpen}
          onOpen={() => setDatePickerOpen(true)}
          onClose={() => setDatePickerOpen(false)}
          format={DISPLAY_DATE_FORMAT}
          value={field.value ? dayjs(field.value) : null}
          disabled={props.isDisabled}
          onChange={value => {
            field.onChange(value ? dayjs(value).format('YYYY-MM-DD') : null);
          }}
          slotProps={{
            popper: {
              sx: popperDateSx,
              placement: 'bottom-start',
            },
            textField: {
              size: 'small',
              variant: 'outlined',
              disabled: props.isDisabled,
              error: !!errors[props.fieldName] && props.showError,
              onClick: () => setDatePickerOpen(true),
              InputProps: {
                style: { fontSize: '1.6rem' },
              },
            },
          }}
        />
      )}
      {...props}
    />
  );
};
